module.exports = __webpack_public_path__ + "img/1537498768.7f0650db.jpg";